import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "nes-container with-title" }
const _hoisted_3 = {
  class: "title marker",
  style: {"font-size":"24px","margin-top":"-45px"}
}
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 w-full bg-black text-white" }, "Variable reward:", -1)
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 w-full bg-black text-white" }, "Fixed reward:", -1)
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_4, "Accrued reward: " + _toDisplayString(_ctx.reward.accruedReward / 1000000000), 1),
      _createElementVNode("div", _hoisted_5, "Paid out reward: " + _toDisplayString(_ctx.reward.paidOutReward / 1000000000), 1),
      (_ctx.parseRewardType(_ctx.farmReward) === 'variable')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, " Last recorded accrued reward per gem: " + _toDisplayString(_ctx.numeral(
              _ctx.reward.variableRate.lastRecordedAccruedRewardPerRarityPoint.n / 10 ** 15
            ).format('0,0.0')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, " Staking begins: " + _toDisplayString(_ctx.parseDate(_ctx.reward.fixedRate.beginStakingTs)), 1),
            _createElementVNode("div", _hoisted_12, " Last updated: " + _toDisplayString(_ctx.parseDate(_ctx.reward.fixedRate.lastUpdatedTs)), 1)
          ]))
    ])
  ]))
}